<mat-dialog-actions class="justify-content-between">

    <h4 class="f-s-16 f-w-600 m-b-16">@if(patientfill){
        <h3>{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.PATIENT' | translate }}</h3>
        }@else{
        <h3>{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.PATIENT' | translate }}</h3>
        }
    </h4>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>

<div *ngIf="isLoading" class="loader-wrapper">
    <mat-spinner diameter="40"></mat-spinner>
</div>

<mat-divider *ngIf="!isLoading"></mat-divider>
<mat-dialog-content class="mat-typography" *ngIf="!isLoading">
    <div class="row">
        <div class="col-12">
            <mat-tab-group mat-stretch-tabs="false" [color]="'primary'">
                <mat-tab label="Patient details">
                    <div class="mat-body-1 p-16 rounded m-t-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="d-flex align-items-center m-b-16">
                                    <div class="flex flex-col items-center relative" id="avatar-container"
                                        (mouseenter)="showAddPhotoOverlay=true">
                                        <!--  (mouseleave)="showAddPhotoOverlay=false" -->

                                        <img class="avatar-photo" #avatarImg [src]="profileImagePathSrc"
                                            id="avatar-photo" alt="User avatar"
                                            fallbackImage="assets/images/profile/user-1.jpg">


                                        <div *ngIf="showAddPhotoOverlay" id="add-photo-overlay" class="avatar-photo"
                                            style="text-align: center;">
                                            <!-- Hover Button -->
                                            <button id="add-avatar-photo-button" class="center-positon-absolute"
                                                mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                                                (mouseenter)="openMenu(menuTrigger)">
                                                <mat-icon>add_a_photo</mat-icon>
                                            </button>

                                            <!-- Hover Menu -->
                                            <mat-menu #menu="matMenu" (closed)="onMenuClosed()">
                                                <button mat-menu-item (click)="takePhotoOnWebCamera()">
                                                    {{ 'LABEL.TAKE_PHOTO' | translate }}
                                                    <mat-icon>photo_camera</mat-icon>
                                                </button>
                                                <button mat-menu-item
                                                    (click)="fileInput.click();showAddPhotoOverlay=false">
                                                    {{ 'LABEL.BROWSER_PHOTO' | translate }}
                                                    <mat-icon>collections icon</mat-icon>
                                                </button>
                                            </mat-menu>

                                        </div>

                                    </div>
                                    <input #fileInput type="file" (change)="onFileChanged($event)" name="avatar"
                                        accept="image/png, image/jpeg" style="display:none;">
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-center">
                            <!-- Salute (2 columns) -->
                            <div class="col-lg-2">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.SALUTE' | translate }}</mat-label>
                                    <mat-select [(ngModel)]="patientdata.salute">
                                        @for (salute of Salutes; track salute) {
                                        <mat-option [value]="salute">{{ salute }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- First Name (3.33 cols), Middle Name (3.33 cols), Last Name (3.33 cols) -->
                            <div class="col-lg-10">
                                <div class="row">
                                    <!-- First Name -->
                                    <div class="col-lg-4">
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>{{ 'LABEL.FIRSTNAME_LABEL' | translate }}</mat-label>
                                            <input matInput placeholder="{{ 'LABEL.FIRSTNAME_LABEL' | translate }}"
                                                [(ngModel)]="patientdata.firstName" (blur)="trimName('firstName')"
                                                required name="firstName" #firstName="ngModel" pattern="^[a-zA-Z]+$"
                                                maxlength="40">
                                            <mat-error
                                                *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)">
                                                <span *ngIf="firstName.errors?.['required']">
                                                    {{ 'REQUIRED.NAME' | translate }}
                                                </span>
                                                <span *ngIf="firstName.errors?.['pattern']">
                                                    {{ 'VALIDATION.ALPHABETS' | translate }}
                                                </span>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Middle Name -->
                                    <div class="col-lg-4">
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>{{ 'LABEL.MIDDLENAME_LABEL' | translate }}</mat-label>
                                            <input matInput placeholder="{{ 'LABEL.MIDDLENAME_LABEL' | translate }}"
                                                [(ngModel)]="patientdata.middleName" (blur)="trimName('middleName')"
                                                name="middleName" #middleName="ngModel" pattern="^[a-zA-Z]+$"
                                                maxlength="40">
                                            <mat-error
                                                *ngIf="middleName.invalid && (middleName.dirty || middleName.touched)">
                                                <span *ngIf="middleName.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' |
                                                    translate }}</span>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <!-- Last Name -->
                                    <div class="col-lg-4">
                                        <mat-form-field appearance="outline" class="w-100">
                                            <mat-label>{{ 'LABEL.LASTNAME_LABEL' | translate }}</mat-label>
                                            <input matInput placeholder="{{ 'LABEL.LASTNAME_LABEL' | translate }}"
                                                [(ngModel)]="patientdata.lastName" (blur)="trimName('lastName')"
                                                required name="lastName" #lastName="ngModel" pattern="^[a-zA-Z]+$"
                                                maxlength="40">
                                            <mat-error *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)">
                                                <span *ngIf="lastName.errors?.['required']">{{ 'REQUIRED.NAME' |
                                                    translate }}</span>
                                                <span *ngIf="lastName.errors?.['pattern']">{{ 'VALIDATION.ALPHABETS' |
                                                    translate }}
                                                </span>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row">
                            <div class="col-lg-6 m-t-10">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.DOB_LABEL' | translate }}</mat-label>
                                    <input matInput [matDatepicker]="picker" [(ngModel)]="patientdata.birthDate"
                                        [min]="minDate" required [max]="maxDate" placeholder="DD/MM/YYYY"
                                        (ngModelChange)="calculateAge($event)" name="DateofBirth"
                                        #DateofBirth="ngModel">
                                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker [color]="'primary'"></mat-datepicker>
                                    <mat-hint>DD/MM/YYYY</mat-hint>
                                    <mat-error
                                        *ngIf="DateofBirth.invalid && (DateofBirth.dirty || DateofBirth.touched)">
                                        <span *ngIf="DateofBirth.errors?.['required']">{{ 'REQUIRED.SELECT_DATE' |
                                            translate }}</span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-6">
                                <mat-form-field appearance="outline" class="w-100 m-t-10">
                                    <mat-label>{{ 'LABEL.AGE' | translate }}</mat-label>
                                    <input matInput type="text" placeholder="{{ 'LABEL.AGE' | translate }}"
                                        [(ngModel)]="patientdata.age" (ngModelChange)="calculateDateOfBirth($event)"
                                        [matAutocomplete]="ageAuto">

                                    <mat-autocomplete #ageAuto="matAutocomplete"
                                        (optionSelected)="onAgeSuggestionSelected($event.option.value)">

                                        <mat-option *ngFor="let suggestion of ageSuggestions" [value]="suggestion">
                                            {{ suggestion }}
                                        </mat-option>

                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>

                        </div>

                        <div class="row m-b-16">
                            <div class="col-lg-6">
                                <ng-container *ngIf="listOfGender.length else noOptions">
                                    <mat-label>{{ 'LABEL.GENDER' | translate }}:</mat-label>
                                    <mat-radio-group [(ngModel)]="patientdata.gender" required color="primary"
                                        class="radio-inline">
                                        <mat-radio-button *ngFor="let o of listOfGender"
                                            [value]="o.value">{{o.name}}</mat-radio-button>
                                    </mat-radio-group>
                                </ng-container>
                                <ng-template #noOptions>No options available</ng-template>

                            </div>
                            <div class="col-lg-6">
                                <ng-container *ngIf="listOfMaritalStatus.length else noOptions">
                                    <mat-label>{{ 'LABEL.MARITAL_STATUS' | translate }}:</mat-label>
                                    <mat-radio-group [(ngModel)]="patientdata.maritalStatus" required color="primary"
                                        class="radio-inline">
                                        <mat-radio-button *ngFor="let o of listOfMaritalStatus"
                                            [value]="o.name">{{o.name}}</mat-radio-button>
                                    </mat-radio-group>
                                </ng-container>
                                <ng-template #noOptions>No options available</ng-template>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.EDUCATION' | translate }}</mat-label>
                                    <input type="text" matInput placeholder="{{ 'LABEL.EDUCATION' | translate }}"
                                        [matAutocomplete]="autoEducation" [(ngModel)]="patientdata.education"
                                        name="education" (input)="filterLookup($event, 'education')" maxlength="50" />
                                    <mat-autocomplete #autoEducation="matAutocomplete">
                                        <mat-option *ngFor="let edu of filteredEducationList" [value]="edu.value">
                                            {{ edu.value }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-6">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.AADHAR_LABEL' | translate }}</mat-label>
                                    <input matInput [type]="hideData ? 'password' : 'text'"
                                        placeholder="{{ 'LABEL.AADHAR_LABEL' | translate }}"
                                        [(ngModel)]="patientdata.aadhaarNumber" #aadhaarNumber="ngModel"
                                        name="aadhaarNumber" maxlength="12" minlength="12" appAllowOnlyDigits>
                                    <button mat-icon-button matSuffix type="button" (click)="hideData = !hideData">
                                        <mat-icon class="icon-eye">{{ hideData ? 'visibility' : 'visibility_off'
                                            }}</mat-icon>
                                    </button>
                                    <mat-error
                                        *ngIf="aadhaarNumber.invalid && (aadhaarNumber.dirty || aadhaarNumber.touched)">
                                        <span
                                            *ngIf="aadhaarNumber.errors?.['minlength'] || aadhaarNumber.errors?.['maxlength']">
                                            {{ 'REQUIRED.MINIMUM12' | translate }}
                                        </span>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4">
                                <mat-form-field appearance="outline" class="w-100">

                                    <mat-label>{{ 'LABEL.BLOOD_GROUP' | translate }}</mat-label>
                                    <mat-select [(ngModel)]="patientdata.bloodGroup">
                                        @for (blood of bloodgroupdetails; track blood) {
                                        <mat-option [value]="blood">{{blood}}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.BLOOD_PRESURE_LABEL' | translate }}</mat-label>
                                    <input matInput placeholder="120/80" [(ngModel)]="patientdata.bloodPressure"
                                        pattern="^\d{2,3}/\d{2,3}$" maxlength="7" name="bloodpressure"
                                        #bloodpressure="ngModel">
                                    <mat-error *ngIf="bloodpressure.errors?.['pattern'] && bloodpressure.touched">
                                        {{ 'REQUIRED.Blood_PRESURE' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.WEIGHT' | translate }}</mat-label>
                                    <input type="number" matInput placeholder="{{ 'LABEL.WEIGHT' | translate }}"
                                        [(ngModel)]="patientdata.weight" maxlength="3" min="0" max="999"
                                        pattern="^[0-9]+$" name="weight" #weight="ngModel" maxlength="3">
                                    <mat-error *ngIf="weight.errors?.['min'] && weight.touched">
                                        {{ 'REQUIRED.MINIMUM_WEIGHT' | translate }}
                                    </mat-error>
                                    <mat-error *ngIf="weight.errors?.['max'] && weight.touched">
                                        {{ 'REQUIRED.MAXIMUM_WEIGHT' | translate }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.FAMILY_DR' | translate }}</mat-label>
                                    <input #familyDrInput type="text" matInput [(ngModel)]="patientdata.familyDr"
                                        [matAutocomplete]="autoExternalEntities" (input)="onFamilyDrInput($event)"
                                        placeholder="{{ 'LABEL.FAMILY_DR' | translate }}" maxlength="100" />
                                    <mat-autocomplete #autoExternalEntities="matAutocomplete"
                                        [displayWith]="displayFamilyDr"
                                        (optionSelected)="onFamilyDoctorSelected($event.option.value)">
                                        <mat-option *ngIf="shouldShowAddOption()"
                                            (click)="addExternalEntities(familyDrInputValue)" [value]="null">
                                            <span class="f-w-600 f-s-15">{{ 'LABEL.ADD_LABEL' | translate }}
                                                "{{familyDrInputValue }}"</span>
                                        </mat-option>
                                        <mat-option *ngFor="let externalEntities of filteredExternalEntitiesList"
                                            [value]="externalEntities">
                                            <span class="f-s-15">{{ externalEntities.name }}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.ALLERGY' | translate }}</mat-label>
                                    <input type="text" matInput [(ngModel)]="patientdata.allergy"
                                        [matAutocomplete]="autoAllergy" (input)="filterLookup($event, 'allergy')"
                                        placeholder="{{ 'LABEL.ALLERGY' | translate }}" maxlength="200" />
                                    <mat-autocomplete #autoAllergy="matAutocomplete">
                                        <mat-option *ngFor="let allergy of filteredAllergyList" [value]="allergy.value">
                                            {{ allergy.value }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-4">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>{{ 'LABEL.SENSITIVITY' | translate }}</mat-label>
                                    <input type="text" matInput [(ngModel)]="patientdata.sensitivity"
                                        [matAutocomplete]="autoSensitivity"
                                        (input)="filterLookup($event, 'sensitivity')"
                                        placeholder="{{ 'LABEL.SENSITIVITY' | translate }}" maxlength="200" />
                                    <mat-autocomplete #autoSensitivity="matAutocomplete">
                                        <mat-option *ngFor="let sens of filteredSensitivityList" [value]="sens.value">
                                            {{ sens.value }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-tab>


                <mat-tab label="Contact Address Details">
                    <app-contact-address [patient]="patientdata"></app-contact-address>
                    <app-contact-detail [patient]="patientdata"></app-contact-detail>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</mat-dialog-content>
<mat-divider *ngIf="!isLoading"></mat-divider>
<mat-dialog-actions *ngIf="!isLoading">
    <div class="row m-t-4 p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button (click)="onCloseDialog()" class="m-r-5">{{ 'BUTTON.BTN_CLOSE' | translate
                }}</button>
            @if(patientfill){

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onUpdatePatient()"
                [disabled]="isSaveDisabled()">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
            }
            @else{
            <button mat-flat-button color="primary" class=" m-l-4" (click)="onSavePatient()"
                [disabled]="isSaveDisabled()">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
            }
        </div>
    </div>
</mat-dialog-actions>